export default __webpack_public_path__ + "static/media/python.cd1e1de5.svg";